import { render } from "./ProductWeightImport.vue?vue&type=template&id=81b991a0"
import script from "./ProductWeightImport.vue?vue&type=script&lang=js"
export * from "./ProductWeightImport.vue?vue&type=script&lang=js"

import "./ProductWeightImport.vue?vue&type=style&index=0&id=81b991a0&lang=css"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__